// extracted by mini-css-extract-plugin
export var delBtn = "meal-type-label-module--del-btn--c320e";
export var label = "meal-type-label-module--label--7e6f2";
export var name = "meal-type-label-module--name--b556e";